/* K°ROL Hero – navigation et swipe, compatible avec le rechargement Shopify. */
(() => {
  'use strict';
  if (window.__korolHeroNavReady) return;
  window.__korolHeroNavReady = true;

  const instances = new WeakMap();

  function init(carousel) {
    if (!carousel || instances.has(carousel)) return instances.get(carousel);
    const slides = Array.from(carousel.querySelectorAll('.korol-hc__slide'));
    const dots = Array.from(carousel.querySelectorAll('[data-kh-dot]'));
    const stage = carousel.querySelector('.korol-hc__stage');
    const state = {
      carousel, slides, dots, stage, index: Math.max(0, slides.findIndex(s => s.hasAttribute('data-active'))),
      delay: Math.max(3000, Number(carousel.dataset.delay) || 6000),
      timer: null, hovered: false, focused: false, visible: true,
      touchStart: null, suppressClickUntil: 0, observer: null
    };
    instances.set(carousel, state);
    if (!slides.length) return state;

    go(state, state.index);
    if (slides.length < 2) return state;

    carousel.addEventListener('mouseenter', () => { state.hovered = true; });
    carousel.addEventListener('mouseleave', () => { state.hovered = false; });
    carousel.addEventListener('focusin', () => { state.focused = true; });
    carousel.addEventListener('focusout', () => { state.focused = carousel.contains(document.activeElement); });
    if (stage) {
      stage.addEventListener('touchstart', e => {
        if (e.touches.length !== 1) { state.touchStart = null; return; }
        const t = e.touches[0];
        state.touchStart = { x: t.clientX, y: t.clientY };
      }, { passive: true });
      stage.addEventListener('touchend', e => {
        if (!state.touchStart || !e.changedTouches.length) return;
        const t = e.changedTouches[0];
        const dx = t.clientX - state.touchStart.x;
        const dy = t.clientY - state.touchStart.y;
        state.touchStart = null;
        if (Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          state.suppressClickUntil = Date.now() + 350;
          go(state, state.index + (dx < 0 ? 1 : -1));
          restart(state);
        }
      }, { passive: true });
      stage.addEventListener('touchcancel', () => { state.touchStart = null; }, { passive: true });
      stage.addEventListener('click', e => {
        if (Date.now() < state.suppressClickUntil) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    }
    if ('IntersectionObserver' in window) {
      state.observer = new IntersectionObserver(entries => {
        state.visible = entries.some(entry => entry.isIntersecting);
      }, { threshold: 0.1 });
      state.observer.observe(carousel);
    }
    restart(state);
    return state;
  }

  function go(state, target) {
    const n = state.slides.length;
    if (!n) return;
    state.index = ((target % n) + n) % n;
    state.slides.forEach((slide, i) => {
      const selected = i === state.index;
      if (selected) slide.setAttribute('data-active', '');
      else slide.removeAttribute('data-active');
      slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
      if ('inert' in slide) slide.inert = !selected;
    });
    state.dots.forEach((dot, i) => {
      dot.setAttribute('aria-current', i === state.index ? 'true' : 'false');
      dot.setAttribute('aria-pressed', i === state.index ? 'true' : 'false');
    });
  }

  function restart(state) {
    if (state.timer) clearInterval(state.timer);
    if (state.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    state.timer = setInterval(() => {
      if (!state.carousel.isConnected) { clearInterval(state.timer); state.timer = null; return; }
      if (!document.hidden && state.visible && !state.hovered && !state.focused) {
        go(state, state.index + 1);
      }
    }, state.delay);
  }

  function scan(root = document) {
    if (root.matches && root.matches('korol-hero-carousel')) init(root);
    root.querySelectorAll?.('korol-hero-carousel').forEach(init);
  }

  document.addEventListener('click', e => {
    const dot = e.target.closest?.('[data-kh-dot]');
    if (!dot) return;
    const carousel = dot.closest('korol-hero-carousel');
    if (!carousel) return;
    const state = init(carousel);
    const i = state.dots.indexOf(dot);
    if (i >= 0) {
      e.preventDefault();
      go(state, i);
      restart(state);
    }
  });

  document.addEventListener('shopify:section:load', e => scan(e.target));
  document.addEventListener('shopify:block:select', e => {
    const slide = e.target.closest?.('.korol-hc__slide');
    const carousel = slide?.closest('korol-hero-carousel');
    if (carousel) {
      const state = init(carousel);
      const idx = state.slides.indexOf(slide);
      if (idx >= 0) go(state, idx);
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  else scan();
})();